@if (isLoading) {
	<div class="loading-overlay">
		<img class="spinner" src="./assets/spinner2.gif" />
	</div>
}

<div class="service-header-wrapper">
	<h2 class="mat-heading" style="flex: 2">{{ 'masterdata.cutting.rules' | translate }}</h2>
	<div class="service-header-buttons">
		<div class="acies-density-high acies-list-search-field">
			<mat-form-field>
				<input matInput [placeholder]="'insights.administration.users.search' | translate" [(ngModel)]="rulesFilter" />
				<button mat-icon-button matPrefix>
					<mat-icon svgIcon="acies_search"></mat-icon>
				</button>
			</mat-form-field>
		</div>
		<header-sub-menu [favoriteItems]="favoriteItems" [menuItems]="menuItems"></header-sub-menu>
	</div>
</div>
@if (!isLoading) {
	<div class="flex flex-dir-col gap-24">
		<div class="flex gap-64">
			<mat-form-field [formGroup]="emptySpacesBetweenRulesForm" appearance="outline" class="dialog w-none min-w">
				@if (emptySpacesBetweenRulesControls['emptySpacesBetweenRules'].invalid && emptySpacesBetweenRulesControls['emptySpacesBetweenRules'].touched) {
					<mat-error>
						{{ 'masterdata.racking.configs.errors.empty' | translate }}
					</mat-error>
				}
				<mat-label class="mat-body-1">
					{{ 'masterdata.racking.configs.emptySpacesBetweenRules' | translate }}
				</mat-label>
				<input matInput inputmode="numeric" formControlName="emptySpacesBetweenRules" (blur)="updateConfiguration()" (ngModelChange)="updateEmptyRulesFormValidity()" [(ngModel)]="emptySpacesBetweenRules" />
			</mat-form-field>
			<mat-form-field [formGroup]="componentsForm" appearance="outline" class="dialog w-none min-w">
				@if (componentsControls['components'].invalid && componentsControls['components'].touched) {
					<mat-error>
						{{ 'masterdata.racking.configs.errors.empty' | translate }}
					</mat-error>
				}
				<mat-label class="mat-body-1">
					{{ 'masterdata.racking.configs.componentsSorting' | translate }}
				</mat-label>
				<input matInput formControlName="components" (blur)="updateConfiguration()" (ngModelChange)="updateComponentsFormValidity()" [(ngModel)]="components" />
				<button mat-icon-button matSuffix [matTooltip]="('masterdata.racking.configs.componentsExample' | translate) + ': VSK,OKA,OVK,OKB,HSK,UKB,UNK,UKA,VSR,ORA,OVR,ORB,HSR,URB,UNR,URA,PSX,SPX,GLST,PRFX,PVX'" matTooltipClass="multiline-tooltip" aria-label="Help">
					<mat-icon>help_outline</mat-icon>
				</button>
			</mat-form-field>
		</div>
	</div>
}
<app-generictable
	[hidden]="(count$ | async) <= 0"
	[tableSource]="tableSource"
	[hasSelectColumn]="false"
	[tableColumns]="registerTableColumns"
	[pageSizes]="pageSizes"
	[initialPageSize]="initialPageSize"
	[showFirstLastButtons]="false"
	[filterWord]="rulesFilter"
	[rowActions]="regRowActions"
	(selectedList)="handleSelected($event)"
	(menuEmitter)="handleRowMenuAction($event)"
	(paginatorEmitter)="handleReloadData($event)"
	[totalRowCount]="count$ | async"></app-generictable>
